import React, { useEffect, useState,useContext } from "react";
import { CiHeart } from "react-icons/ci";
import { DContext } from "../../../context/Datacontext";
import { FaStar } from "react-icons/fa";
import EnRoll from "../../../components/common/EnRoll";
import ThumNail from '../../../assets/LearnerCentricApproach.png'

export const ExploreCourses = () => {
    const { BeURL } = useContext(DContext)
    const [courses, setCourses] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [enRollCourse, setEnRollCourse] = useState(null)

    const [filters, setFilters] = useState({
        search: "",
        category: "",
        level: "",
        rating: "",
        minPrice: "",
        maxPrice: "",
        sortBy: "latest"
    });
useEffect(()=>{
    const fetchCourses = async () => {

        const params = new URLSearchParams({
            page,
            ...filters
        });

        const res = await fetch(`${BeURL}/public-courses?${params}`);
        const data = await res.json();

        setCourses(data.courses);
        setTotalPages(data.totalPages);
    };
    fetchCourses()
}, [page, filters ,BeURL])




    const handleChange = (e) => {
        setFilters({ ...filters, [e.target.name]: e.target.value });
        setPage(1);
    };


    return (
        <section className="py-20 bg-gray-50">

            <div className="max-w-7xl mx-auto px-4">

                {/* HEADER */}
                <h2 className="text-4xl font-bold text-center mb-10">
                    Explore Courses
                </h2>
                {/* FILTER BAR */}
                <div className="bg-white p-5 rounded-xl shadow-sm border mb-10">

                    <div className="grid lg:grid-cols-6 md:grid-cols-3 sm:grid-cols-2 gap-4">

                        {/* SEARCH */}
                        <input
                            type="text"
                            name="search"
                            placeholder="Search courses..."
                            className="border rounded-lg px-4 py-2 focus:ring-2 focus:ring-indigo-500 outline-none"
                            onChange={handleChange}
                        />

                        {/* CATEGORY */}
                        <select
                            name="category"
                            onChange={handleChange}
                            className="border rounded-lg px-4 py-2 focus:ring-2 focus:ring-indigo-500 outline-none"
                        >
                            <option value="">All Categories</option>
                            <option value="development">Development</option>
                            <option value="design">Design</option>
                            <option value="database">Database</option>
                        </select>

                        {/* LEVEL */}
                        <select
                            name="level"
                            onChange={handleChange}
                            className="border rounded-lg px-4 py-2 focus:ring-2 focus:ring-indigo-500 outline-none"
                        >
                            <option value="">All Levels</option>
                            <option value="beginner">Beginner</option>
                            <option value="intermediate">Intermediate</option>
                            <option value="advanced">Advanced</option>
                        </select>

                        {/* RATING */}
                        <select
                            name="rating"
                            onChange={handleChange}
                            className="border rounded-lg px-4 py-2 focus:ring-2 focus:ring-indigo-500 outline-none"
                        >
                            <option value="">Any Rating</option>
                            <option value="4">4★ & up</option>
                            <option value="3">3★ & up</option>
                        </select>

                        {/* PRICE RANGE */}
                        <div className="flex gap-2">
                            <input
                                type="number"
                                name="minPrice"
                                placeholder="Min ₹"
                                className="border rounded-lg px-3 py-2 w-full focus:ring-2 focus:ring-indigo-500 outline-none"
                                onChange={handleChange}
                            />

                            <input
                                type="number"
                                name="maxPrice"
                                placeholder="Max ₹"
                                className="border rounded-lg px-3 py-2 w-full focus:ring-2 focus:ring-indigo-500 outline-none"
                                onChange={handleChange}
                            />
                        </div>

                        {/* SORT */}
                        <select
                            name="sortBy"
                            onChange={handleChange}
                            className="border rounded-lg px-4 py-2 focus:ring-2 focus:ring-indigo-500 outline-none"
                        >
                            <option value="latest">Sort: Latest</option>
                            <option value="priceLow">Price: Low → High</option>
                            <option value="priceHigh">Price: High → Low</option>
                            <option value="rating">Top Rated</option>
                            <option value="popular">Most Popular</option>
                        </select>

                    </div>
                </div>
                {/* COURSE GRID */}
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {courses && courses.map((course) => (
                        <div
                            key={course._id}
                            className="bg-secondary-50 rounded-2xl shadow-md hover:shadow-xl transition duration-300 overflow-hidden flex flex-col group"
                        >

                            {/* IMAGE */}
                            {/* IMAGE */}
                            <div className="relative overflow-hidden">
                                <img
                                    src={ThumNail || course?.thumbnail?.url}
                                    alt={course?.title}
                                    className="w-full h-48 object-cover group-hover:scale-105 transition duration-300"
                                />

                                {/* BADGES */}
                                <div className="absolute top-3 right-3 flex gap-2">
                                    <span className="bg-white text-gray-700 text-xs px-2 py-1 rounded-full shadow">
                                        {course?.level?.charAt(0).toUpperCase() + course?.level?.slice(1)}
                                    </span>
                                </div>
                            </div>

                            <div className="p-5 flex flex-col flex-grow">
                                {/* DEPARTMENT */}
                                <div className="flex items-center gap-2 mb-2">
                                    <div className="w-6 h-6 rounded-full bg-secondary-100 flex items-center justify-center text-primary-600 text-xs font-bold">
                                        {course.department?.name?.charAt(0)}
                                    </div>

                                    <span className="text-xs text-gray-500 uppercase tracking-wide">
                                        {course.department?.name}
                                    </span>
                                </div>

                                {/* TITLE */}
                                <h3 className="text-lg font-semibold leading-snug line-clamp-2">
                                    {course.title}
                                </h3>

                                {/* DESCRIPTION */}
                                <p className="text-gray-500 text-sm mt-2 line-clamp-2 flex-grow">
                                    {course.shortDescription}
                                </p>

                                {/* RATING */}
                                {course.feedback.length > 0 && (
                                    <div className="flex items-center gap-2 mt-3 text-sm">
                                        <FaStar className="text-yellow-500" />

                                        <span className="font-medium">
                                            {(
                                                course.feedback
                                                    .map((item) => item.rating)
                                                    .reduce((acc, rating) => acc + rating, 0) /
                                                course.feedback.length
                                            ).toFixed(1)}
                                        </span>

                                        <span className="text-gray-500">
                                            ({course.feedback.length} reviews)
                                        </span>
                                    </div>
                                )}

                                {/* PRICE */}
                                <div className="mt-4 flex items-center gap-3">
                                    <span className="text-xl font-bold text-primary-600">
                                        ₹{Math.round(course?.finalPrice)}
                                    </span>

                                    <span className="line-through text-gray-400 text-sm">
                                        ₹{course?.price}
                                    </span>

                                    <span className="text-green-600 text-sm font-semibold">
                                        {(course?.discountPercent * 100).toFixed(0)}% OFF
                                    </span>
                                </div>

                                {/* BUTTON AREA */}
                                <div className="flex items-center justify-between mt-5 gap-5">

                                    {/* WISHLIST */}
                                    <button onClick={() => setEnRollCourse({
                                        courseId: course?._id,
                                        action: "star"
                                    })}>
                                       <CiHeart size={30} />
                                    </button>

                                    {/* ENROLL BUTTON */}
                                    <button onClick={() => setEnRollCourse({
                                        courseId: course?._id,
                                        action: "enroll"
                                    })} className="bg-primary-600 w-full hover:bg-primary-700 text-white text-sm font-medium px-5 py-2 rounded-lg transition">
                                        Enroll Now
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* PAGINATION */}
                <div className="flex justify-center gap-3 mt-12">
                    {[...Array(totalPages)].map((_, i) => (
                        <button
                            key={i}
                            onClick={() => setPage(i + 1)}
                            className={`px-4 py-2 rounded-lg ${page === i + 1
                                    ? "bg-primary-600 text-white"
                                    : "bg-white border"
                                }`}
                        >
                            {i + 1}
                        </button>
                    ))}

                </div>
            </div>



            {enRollCourse && <EnRoll enroll={enRollCourse} setEnRollCourse={setEnRollCourse} />}


        </section>
    );
};